import { Props } from './types'
import Core from './Core'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import styled from 'styled-components'

const Day = ({ day, updateElement, selected = false, used = false }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const select = () => updateElement(day)

  const Wrapper = styled.div`
    width: calc(100% / 5 - 8px * 4 / 5);
  `

  return (
    <Wrapper className={`${used && 'opacity-50'} border border-blue group cursor-pointer`} onClick={select}>
      <div className="bg-blue text-white text-center p-2 text-lg">{t.survey.answer.daySelection.card.title}</div>
      <div
        className={`${
          selected ? 'bg-blue text-white' : ' group-hover:bg-blue group-hover:bg-opacity-10'
        } text-center text-3xl font-bold py-5 transition-all border-t border-white`}
      >
        {day}
      </div>
    </Wrapper>
  )
}

const DaySelection: React.FC<Props<any, number>> = ({ survey, element, answer, updateElement }) => {
  return (
    <div>
      <Core element={element} />
      <div className="flex flex-row flex-wrap gap-[8px] justify-center mt-5">
        {[...new Array(survey.context.amountOfDays)].map((_, index) => (
          <Day
            key={index}
            day={index + 1}
            used={survey.answerCountByUserIdentifier > index}
            selected={answer.dayNumber === index + 1}
            updateElement={updateElement}
          />
        ))}
      </div>
    </div>
  )
}

export default DaySelection
